import { useState, useEffect } from "react";
import { Card, Modal } from "react-bootstrap";
import { useCookies } from "react-cookie";
import moment from "moment";
import http from "../../../common/http-common";
import { toast } from "react-toastify";
import * as Comp from "../../../common/CommonComponents";
import ResponseAttachmentModal from "./ResponseAttachmentModel";
import CssClass from "../../../Styles/common.module.css";
import * as common from "../../../common/common";

const NewResponseCard = (props) => {
  const { authority, reloadData, data: propsData, responseAttachment } = props;
  const { DELETE_REPLY, EDIT_REPLY } = authority || {};
  //console.log("Button Authority for Card:", authority);

  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);
  const [userName] = useState(cookies.USER_NAME);

  const [allData, setAllData] = useState([]);
  const [showView, setShowView] = useState(false);
  const [showAttachment, setShowAttachment] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editDetails, setEditDetails] = useState("");
  const [editResponseId, setEditResponseId] = useState(null);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteResponseId, setDeleteResponseId] = useState(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (propsData !== undefined) {
      let temp = [];
      let attachmentList = [];

      propsData.forEach((data, counter) => {
        if (responseAttachment !== undefined) {
          let attachment = responseAttachment
            .filter(
              (att) =>
                data.ATTACHMENT_ID === att.REFERENCE &&
                att.ATTACHMENT_ID !== data.DEPLOYMENT_ATTACHMENT_ID
            )
            .map((att) => ({
              REFERENCE_ID: att.REFERENCE,
              ATTACHMENT_ID: att.ATTACHMENT_ID,
              ATTACHMENT_NAME: att.ATTACHMENT_NAME,
              ATTACHMENT_PATH: att.ATTACHMENT_PATH,
            }));
          attachmentList.push([attachment]);
        }

        temp.push({
          TICKET_MST_ID: data.TICKET_MST_ID,
          REFERENCE_ID: data.ATTACHMENT_ID,
          TICKET_RESPONSE_ID: data.TICKET_RESPONSE_ID,
          RESPONSE_DETAILS: data.RESPONSE_DETAILS,
          UPDATE_ID: data.UPDATE_ID,
          UPDATE_NAME: data.UPDATE_NAME,
          UPDATE_DATETIME: data.UPDATE_DATETIME,
          DEPLOYMENT_ATTACHMENT_ID: data.DEPLOYMENT_ATTACHMENT_ID,
          ATTACHMENT_DETAILS: attachmentList[counter]?.[0] || [],
          TICKET_RESPONSE_ID: data.TICKET_RESPONSE_ID,
        });
      });
      setAllData(temp);
      //console.log("data :",temp);
    }
  }, [propsData, responseAttachment, userId]);

  const showViewModal = (e, attach) => {
    setShowView(true);
    setShowAttachment(attach);
  };
  const hideViewModal = () => setShowView(false);

  function handleEdit(data) {
    setEditResponseId(data.TICKET_RESPONSE_ID);
    setEditDetails(data.RESPONSE_DETAILS);
    setEditModalVisible(true);
  }

  function handleDelete(responseId) {
    setDeleteResponseId(responseId);
    setShowDeleteModal(true);
  }

  function confirmDelete() {
    http
      .delete(`api/response/DeleteReply?_responseId=${deleteResponseId}&_userId=${userId}`)
      .then(() => {
        toast.success("Reply deleted successfully.");
        reloadData();
      })
      .catch((err) => toast.error(err));
    setShowDeleteModal(false);
  }

  function saveEdit() {
    http
      .post(`api/response/UpdateReply`, {
        TICKET_RESPONSE_ID: editResponseId,
        RESPONSE_DETAILS: editDetails,
        UPDATE_ID: userId,
      })
      .then(() => {
        toast.success("Reply updated successfully.");
        setEditModalVisible(false);
        reloadData();
      })
      .catch((err) => toast.error(err));
  }

  return (
    <>
      {allData.map((data) => {
        const isOwner = data.UPDATE_NAME === userName;
        return (
          <div key={data.TICKET_RESPONSE_ID} style={{ marginBottom: "1rem" }}>
            <Card
              style={{
                marginLeft: isOwner && !isMobile ? "600px" : isMobile && isOwner ? "30px" : "0",
                marginRight: !isOwner && !isMobile ? "600px" : isMobile && !isOwner ? "30px" : "0",
                borderRadius: isOwner ? "1rem 1rem 0 1rem" : "1rem 1rem 1rem 0",
              }}
            >
              <Card.Body
                style={{
                  backgroundColor: isOwner ? "lightblue" : undefined,
                  borderRadius: isOwner ? "1rem 1rem 0 0" : undefined,
                }}
              >
                {data.RESPONSE_DETAILS.startsWith("TICKET CANCELLED") &&
                !data.RESPONSE_DETAILS.endsWith("Reason:") ? (
                  <Card.Text>
                    <strong>{data.RESPONSE_DETAILS.substring(0, data.RESPONSE_DETAILS.indexOf("Reason"))}</strong>
                    <br />
                    {data.RESPONSE_DETAILS.substring(data.RESPONSE_DETAILS.indexOf("Reason"))}
                  </Card.Text>
                ) : (
                  data.RESPONSE_DETAILS.split("\n").map((line, index) => <p key={index}>{line}</p>)
                )}

                {isOwner && EDIT_REPLY === "Y" && !data.RESPONSE_DETAILS.startsWith("Ticket ") && !data.RESPONSE_DETAILS.startsWith("TICKET ") && !data.RESPONSE_DETAILS.startsWith("Agent ") && (
                  <Comp.Button
                    style={{ background: "orange", marginRight: "0.5rem" }}
                    onClick={() => handleEdit(data)}
                  >
                    Edit
                  </Comp.Button>
                )}

                {isOwner && DELETE_REPLY === "Y" && !data.RESPONSE_DETAILS.startsWith("Ticket ") && !data.RESPONSE_DETAILS.startsWith("TICKET ") && !data.RESPONSE_DETAILS.startsWith("Agent ") && (
                  <Comp.Button
                    style={{ background: "red" }}
                    onClick={() => handleDelete(data.TICKET_RESPONSE_ID)}
                  >
                    Delete
                  </Comp.Button>
                )}

                {data.ATTACHMENT_DETAILS.length > 0 && (
                  <div style={{ marginTop: "0.5rem" }}>
                    <Comp.Button id={data.TICKET_RESPONSE_ID} onClick={(e) => showViewModal(e, data.ATTACHMENT_DETAILS)}>
                      Attachment
                    </Comp.Button>
                    <ResponseAttachmentModal responseAttachment={showAttachment} showHide={showView} onHide={hideViewModal} />
                  </div>
                )}
                {/* Deployment Form */}
                {propsData.find(r => r.TICKET_RESPONSE_ID === data.TICKET_RESPONSE_ID)?.DEPLOYMENT_ATTACHMENT_ID && (
                  <div style={{ marginTop: "0.5rem" }}>
                    <Comp.Button
                      type="purple"
                      size="xxl"
                      onClick={() => {
                        const deploymentId =
                          propsData.find(r => r.TICKET_RESPONSE_ID === data.TICKET_RESPONSE_ID)?.DEPLOYMENT_ATTACHMENT_ID;

                        const url =`${common.c_getApiUrl()}api/response/ViewDeploymentAttachment?_attachmentId=${deploymentId}&_user=${userId}`;
                        window.open(url, "_blank");
                      }}
                    >
                      View Deployment Form
                    </Comp.Button>
                  </div>
                )}
              </Card.Body>
              <Card.Footer style={{ backgroundColor: isOwner ? "#0F74DB" : undefined, color: isOwner ? "white" : undefined }}>
                by {data.UPDATE_NAME} on {moment(data.UPDATE_DATETIME).format("DD/MM/YYYY hh:mm:ss A")}
              </Card.Footer>
            </Card>
          </div>
        );
      })}

      {/* Edit Modal */}
      <Modal show={editModalVisible} onHide={() => setEditModalVisible(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Reply</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <textarea
            value={editDetails}
            onChange={(e) => setEditDetails(e.target.value)}
            style={{ width: "100%", minHeight: "100px" }}
          />
        </Modal.Body>
        <Modal.Footer style={{ justifyContent: "center", width: "100%" }}>
          <Comp.Button
            type="general"
            onClick={saveEdit}
          >
            Save <img src={require("../../../assets/save-icon.png")} alt="Save" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
          </Comp.Button>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <Comp.Button
            type="cancel"
            onClick={() => setEditModalVisible(false)}
          >
            Cancel <img src={require("../../../assets/cancel-icon.png")} alt="Cancel" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "2px" }} />
          </Comp.Button>
        </Modal.Footer>
      </Modal>

      {/* Delete Confirm Modal */}
      <Comp.ConfirmModal
        show={showDeleteModal}
        title="Delete Reply"
        onConfirm={confirmDelete}
        onHide={() => setShowDeleteModal(false)}
      >
        Delete this Reply?
      </Comp.ConfirmModal>
    </>
  );
};

export default NewResponseCard;
